import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export class OIDCIntegrationError extends CodedError {
  static get errorName() {
    return errorCodes.oidcIntegrationError.code;
  }

  constructor(message: string = errorCodes.oidcIntegrationError.message) {
    super(message);
    this.code = errorCodes.oidcIntegrationError.code;
    this.message = `${message} ${errorCodes.oidcIntegrationError.code}`;
    this.name = errorCodes.oidcIntegrationError.name;
  }
}
